import { computed } from 'vue';
import { CampaignManagementAPIClient } from '@studyportals/campaign-management-api-interface';
import cookieHandler from '@/plugins/cookie-handler';
import store from '@/store';
import { EnrichedCampaignGeotargetingDto } from '@studyportals/campaign-management-api-interface/src/domain/campaign/enriched-campaign-geotargeting.dto';

class CampaignDataHandler {
	private client: CampaignManagementAPIClient;
	private readonly tokenId: string;

	private campaignId = computed((): number => {
		return store.getters.campaignId();
	});

	constructor() {
		this.tokenId = cookieHandler.retrieveTokenIdCookie();
		this.client = new CampaignManagementAPIClient(webpackDefinitions.CAMPAIGN_MANAGEMENT_API_URl);
	}

	public async retrieveCampaignEntities(): Promise<EnrichedCampaignGeotargetingDto | null> {
		let entities: EnrichedCampaignGeotargetingDto | null = null;

		try {
			entities = await this.client.getCampaignGeotargeting(this.campaignId.value, this.tokenId);
			store.mutations.setCampaignData(entities);
		} catch (e) {
			throw new Error('Something went wrong while retrieving geotargeting data from the CMA.', { cause: e });
		}

		return entities;
	}
}

export default new CampaignDataHandler();
